// opervex-frontend/src/layout/MainLayout.js

import { useState } from "react";
import CustomAlert from "../components/CustomAlert";
import ToastAlert from "../components/ToastAlert";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Sidebar from "./Sidebar/Sidebar";
import "./layout.css";

const MainLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [hidden, setHidden] = useState(false);

  // Alterna modo ícone (collapsed)
  const toggleCollapse = () => {
    setCollapsed((prev) => !prev);
  };

  // Oculta completamente a sidebar
  const toggleHidden = () => {
    setHidden((prev) => !prev);
  };

  return (
    <div className="layout-wrapper">
      <CustomAlert />
      <ToastAlert />

      <Header onToggleSidebar={toggleCollapse} onToggleHidden={toggleHidden} collapsed={collapsed} hidden={hidden} />

      <div className="layout-body">
        <div className={`layout-sidebar ${collapsed ? "collapsed" : ""}`} hidden={collapsed ? "hidden" : ""}>
          <Sidebar collapsed={collapsed} />
        </div>

        <div className="layout-content">{children}</div>
      </div>

      <Footer />
    </div>
  );
};

export default MainLayout;
